import NavItemLink from "components/base/NavItemLink";
import Block from "components/layout/Block";
import Panel from "./Panel";
import List from "./List";
import Item from "./Item";
import { Condition } from "components/conditional";

const Factory = ({
	items,
	listProps,
	expandable,
	emptyItem,
	isActionMenuVisible,
	...props
}) => {
	const renderContent = (item) => {
		const { content, ...rest } = item;
		if (typeof content === "function") {
			return item.content(rest);
		}
		return item.content;
	};

	return (
		<Panel appearance="tabs" {...props}>
			<List {...listProps}>
				{items.map((item) => {
					return (
						<NavItemLink
							container={Item}
							to={item.link}
							key={item.key}
							exact={item.exact}
							onClick={(event) => {
								if (item.disabled) {
									event.preventDefault();
								} else if (item.onClick) {
									item.onClick(event);
								}
							}}
							disabled={item.disabled}
						>
							<Item.Content {...listProps}>
								{renderContent(item)}
							</Item.Content>
						</NavItemLink>
					);
				})}

				<Condition value={emptyItem}>
					<Item noHover>
						<Block flex full>
							<Item.Content></Item.Content>
						</Block>
					</Item>
				</Condition>

				<Condition value={expandable && typeof expandable === "object"}>
					<Item expandable isActionMenuVisible={isActionMenuVisible}>
						<Block flex full onClick={expandable.onClick}>
							<Item.Content>{expandable.content}</Item.Content>
						</Block>
					</Item>
				</Condition>
			</List>
		</Panel>
	);
};

export default Factory;
